import { render, staticRenderFns } from "./RadioItems.vue?vue&type=template&id=4d3c8c5f"
import script from "./RadioItems.vue?vue&type=script&lang=ts"
export * from "./RadioItems.vue?vue&type=script&lang=ts"
import style0 from "./RadioItems.vue?vue&type=style&index=0&id=4d3c8c5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports